import {
  Component,
  OnInit,
  ViewEncapsulation,
  Input,
  ViewChild,
  ViewContainerRef,
} from "@angular/core";
import { BaseChartDirective, Color } from "ng2-charts";

import { StackedChartDatasource } from "@/shared-module/models";
import { DialogService } from "@/shared-module/services";

@Component({
  selector: "app-decision-stackedchart",
  templateUrl: "decisionstackedchart.component.html",
  encapsulation: ViewEncapsulation.None,
})
export class DecisionStackedChartComponent implements OnInit {
  @ViewChild("template", { static: true }) template;
  @ViewChild(BaseChartDirective) chart: BaseChartDirective;
  @Input() hidden: boolean;
  data: StackedChartDatasource;
  @Input("data") set setdata(_data: StackedChartDatasource) {
    this.data = _data;
    this.refresh();
  }
  constructor(
    private viewContainerRef: ViewContainerRef,
    private dialogService: DialogService,
  ) {}

  public lineChartColors: Color[] = [];
  public barChartData: any[] = [];
  public barChartLabels: string[] = [];
  public barChartType = "bar";

  public barChartOptions: any = {
    aspectRatio: 1.5,
    tooltips: {
      callbacks: {
        title: (items, data) => {
          if (this.data) {
            return this.data.xLabels[items[0].index];
          }
          return null;
        },
        label: (tooltipItem, data) => {
          if (this.data) {
            let label = data.datasets[tooltipItem.datasetIndex].label || "";

            if (label) {
              label += ": ";
            }
            label +=
              this.data.series[tooltipItem.datasetIndex].yValues[
                tooltipItem.index
              ].yLabel;
            return label;
          }
          return null;
        },
      },
    },
    responsive: true,
    legend: {
      display: true,
      labels: {
        fontColor: "#9797b3",
      },
    },
    scales: {
      xAxes: [
        {
          stacked: true,
          id: "x-axis-0",
          offset: true,
          ticks: {
            fontColor: "white",
          },
          gridLines: {
            drawBorder: false,
            display: false,
          },
        },
      ],
      yAxes: [
        {
          stacked: true,
          ticks: {
            fontColor: "white",
            callback: (value) => {
              if (this.data && this.data.axisY.isPercentage) {
                return value + "%";
              }
              return value;
            },
          },
          id: "y-axis-0",
          gridLines: {
            drawBorder: true,
            borderDash: [2, 5],
            display: true,
          },
        },
      ],
    },
  };

  zoom() {
    this.dialogService.setZoomInfo(this.data.zoomInfo);
  }

  ngOnInit() {
    this.viewContainerRef.createEmbeddedView(this.template);
    this.refresh();
  }

  refresh() {
    if (this.data) {
      this.barChartData = [];
      this.lineChartColors = [];
      this.barChartLabels = [];
      let data = [];
      let ds = {};
      let color = {};

      this.data.xLabels.forEach((v) => {
        this.barChartLabels.push(v);
      });

      this.data.series.forEach((s) => {
        data = [];

        s.yValues.forEach((v) => {
          data.push(v.y);
        });

        // tslint:disable-next-line:object-literal-shorthand
        ds = { data: data, label: s.caption, stack: s.group, barThickness: 40 };
        color = {
          // grey
          backgroundColor: s.color,
          borderColor: s.color,
          pointBackgroundColor: s.color,
          pointBorderColor: s.color,
          pointHoverBackgroundColor: s.color,
          pointHoverBorderColor: s.color,
        };

        this.barChartData.push(ds);
        this.lineChartColors.push(color);
      });
    }
  }
}
